import styled from "styled-components";
import { motion } from "framer-motion";
import theme from "~/styles/theme";

export const StyledMotionDiv = styled(motion.div)`
  background-color: #F5F5F5;
`;

export const Container = styled(motion.div)`
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  padding-bottom: 60px;
`;

export const Text = styled(motion.div)`
  color: var(--Neutral-Gray-900, #1B1B19);
  text-align: center;
  font-size: 16px;
  font-weight: ${(props) => props.resend ? 'bold' : 'normal'};
  line-height: 24px;
  text-transform: ${(props) => props.resend ? 'uppercase' : 'none'};
  text-decoration: ${(props) => props.resend ? 'underline' : 'none'};
  cursor: ${(props) => props.resend ? 'pointer' : 'initial'};
`;

export const Email = styled(motion.div)`
  color: var(--Neutral-Gray-900, #1B1B19);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-radius: 1000px;
  background: var(--cores-ffffff, #FFF);
  padding: 16px 40px;
  min-width: 300px;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    display: inline-block;
  }
`;